import {AfterViewInit, Component, ElementRef, Input, OnInit, ViewChild} from '@angular/core';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-image-viewer',
  templateUrl: './image-viewer.component.html',
  styleUrls: ['./image-viewer.component.scss']
})
export class ImageViewerComponent implements OnInit, AfterViewInit {
  _src: string;
  @Input() noMagnifier: boolean;
  @ViewChild('imageElement', {static: false}) private imageElement: ElementRef;
  @ViewChild('magnifierElement', {static: false}) private magnifierElement: ElementRef;
  @ViewChild('paneElement', {static: false}) private paneElement: ElementRef;
  private image: any;
  private glass: any;
  private pane: any;
  imgClass = '';
  private angle = 0;
  private scale = 100;

  canEnableGlass: boolean;
  glassEnabled: boolean;
  private w: number;
  private h: number;
  private bw: number;
  private zoom: number;

  height: string;
  width: string;
  @ViewChild('magnifyWarnModal', {static: false}) private magnifyWarnModal: ElementRef;

  constructor(private modalService: NgbModal) {
  }

  ngOnInit() {
    this.scale = 100;
    this.zoom = 3;
    this.bw = 3;
  }

  @Input() set src(value: string) {
    this._src = value;
    if (this.glass) {
      this.glass.style.backgroundImage = 'url(' + value + ')';
    }
  }

  get src(): string {
    return this._src;
  }

  resetTool() {
    this.canEnableGlass = true;
    this.glassEnabled = false;
    this.imgClass = '';
    this.height = 'auto';
    this.width = 'auto';
    this.scale = 100;
    const img: any = document.getElementById('main-img');
    if (img) {
      img.style.filter = '';
      img.style.transform = '';
    }
  }

  increase() {
    this.canEnableGlass = false;
    this.glassEnabled = false;
    if (this.scale < 200) {
      this.scale += 10;
      this.width = this.scale + '%';
      this.height = 'auto';
    }
  }

  decrease() {
    this.canEnableGlass = false;
    this.glassEnabled = false;
    if (this.scale > 10) {
      this.scale -= 10;
      this.width = this.scale + '%';
      this.height = 'auto';
    }
  }

  clockwise() {
    this.canEnableGlass = false;
    this.glassEnabled = false;
    if (this.angle >= 360) {
      this.angle = 0;
    }
    this.angle += 90;
    const img: any = document.getElementById('main-img');
    if (90 === this.angle || 270 === this.angle) {
      if (img.height > img.width) {
        img.style.transform = 'translate(' + img.height + 'px, 0px) rotate(' + this.angle + 'deg)';
      } else {
        img.style.transform = 'translate(0px, ' + img.height + 'px) rotate(' + this.angle + 'deg)';
      }
    } else {
      img.style.transform = 'translate(0%, 0%) rotate(' + this.angle + 'deg)';
    }
  }

  anticlockwise() {
    this.canEnableGlass = false;
    this.glassEnabled = false;
    if (this.angle <= 0) {
      this.angle = 360;
    }
    this.angle -= 90;
    const img: any = document.getElementById('main-img');
    if (90 === this.angle || 270 === this.angle) {
      if (img.height > img.width) {
        img.style.transform = 'translate(' + img.height + 'px, 0px) rotate(' + this.angle + 'deg)';
      } else {
        img.style.transform = 'translate(0px, ' + img.height + 'px) rotate(' + this.angle + 'deg)';
      }
    } else {
      img.style.transform = 'translate(0%, 0%) rotate(' + this.angle + 'deg)';
    }
  }

  horizontal() {
    this.canEnableGlass = false;
    this.glassEnabled = false;
    this.width = '100%';
    this.height = 'auto';
  }

  vertical() {
    this.canEnableGlass = false;
    this.glassEnabled = false;
    this.width = 'auto';
    this.height = '100%';
  }

  fit() {
    this.canEnableGlass = false;
    this.glassEnabled = false;
    this.width = '100%';
    this.height = '100%';
  }

  brightness() {
    this.glassEnabled = false;
    const img = document.getElementById('main-img');
    if (img) {
      img.style.filter = 'brightness(1.4)';
    }
  }

  contrast() {
    this.glassEnabled = false;
    // this.imgClass = 'contrast';
    const img = document.getElementById('main-img');
    if (img) {
      img.style.filter = 'contrast(1.4)';
    }
  }

  magnify() {
    if (!this.canEnableGlass) {
      this.modalService.open(this.magnifyWarnModal, {size: 'sm', centered: true, ariaLabelledBy: 'modal-warn-magnify'});
    } else {
      this.glassEnabled = !this.glassEnabled;
    }
  }

  highlighter() {
    this.canEnableGlass = false;
    this.glassEnabled = false;

  }

  invert() {
    this.canEnableGlass = false;
    this.glassEnabled = false;
    this.imgClass = 'invert';
  }

  gray() {
    this.canEnableGlass = false;
    this.glassEnabled = false;
    this.imgClass = 'grayscale';
  }

  ngAfterViewInit(): void {
    this.canEnableGlass = true;
    this.image = this.imageElement.nativeElement;
    this.glass = this.magnifierElement.nativeElement;
    this.pane = this.paneElement.nativeElement;
    this.glass.style.backgroundImage = 'url(' + this.image.src + ')';
    const self = this;
    setTimeout(function () {
      self.glass.style.backgroundSize = (self.image.width * self.zoom) + 'px ' + (self.image.height * self.zoom) + 'px';
      self.w = self.glass.offsetWidth / 2;
      self.h = self.glass.offsetHeight / 2;
    }, 1000);
  }

  moveMagnifier(e: any) {
    if (!this.glassEnabled) {
      return;
    }
    let pos, x, y;
    /*prevent any other actions that may occur when moving over the image*/
    e.preventDefault();
    /*get the cursor's x and y positions:*/
    pos = this.getCursorPos(e);
    x = pos.x;
    y = pos.y;
    /*prevent the magnifier glass from being positioned outside the image:*/
    if (x > this.image.width - (this.w / this.zoom)) {
      x = this.image.width - (this.w / this.zoom);
    }
    if (x < this.w / this.zoom) {
      x = (this.w / this.zoom);
    }
    if (y > this.image.height - (this.h / this.zoom)) {
      y = this.image.height - (this.h / this.zoom);
    }
    if (y < this.h / this.zoom) {
      y = (this.h / this.zoom);
    }
    /*set the position of the magnifier glass:*/
    this.glass.style.left = (x - this.w) + 'px';
    this.glass.style.top = (y - this.h) + 'px';
    /*display what the magnifier glass "sees":*/
    this.glass.style.backgroundPosition = '-' + ((x * this.zoom) - this.w + this.bw) + 'px -' + ((y * this.zoom) - this.h + this.bw) + 'px';
  }

  private getCursorPos(e) {
    let a, x = 0, y = 0;
    // e = e || window.event;
    /*get the x and y positions of the image:*/
    a = this.image.getBoundingClientRect();
    /*calculate the cursor's x and y coordinates, relative to the image:*/
    x = e.pageX - a.left;
    y = e.pageY - a.top;
    /*consider any page scrolling:*/
    x = x - window.pageXOffset;
    y = y - window.pageYOffset;
    return {x: x, y: y};
  }

}
